import gql from 'graphql-tag'

export const companyAddXeeloIntegration = gql`
  mutation companyAddXeeloIntegration($companyId: ID!) {
    companyAddXeeloIntegration(input: { companyId: $companyId }) {
      success
    }
  }
`
